<template>
  <b-card class="product-add-wrapper">
    <b-tabs pills>
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">{{ $t("lbl_product_info") }}</span>
        </template>
        <div class="mt-2 pt-75" :class="{ disable: isDisableEdit }">
          <validation-observer ref="addProductValidation">
            <!-- form -->
            <b-overlay :show="isLoading">
              <b-form>
                <b-row>
                  <b-col cols="12" md="4" xxl="3" order-md="last">
                    <b-media
                      no-body
                      vertical-align="center"
                      class="flex-column mb-2"
                    >
                      <b-media-body class="w-100">
                        <span>Ảnh chính</span>
                        <div
                          class="preview-image border rounded mb-1"
                          @click="triggerChoosePreviewImage"
                        >
                          <div
                            v-if="form.primary_image && !isDisableEdit"
                            v-b-tooltip="{
                              title: $t('lbl_remove_image'),
                              placement: 'bottom',
                              variant: 'danger',
                            }"
                            class="preview-image__clear d-flex flex-column position-absolute"
                            @click.stop="removeImage"
                          >
                            <feather-icon
                              class="m-auto"
                              size="16"
                              icon="XIcon"
                            />
                          </div>
                          <b-img
                            class="preview-image__item w-100 rounded"
                            v-show="form.primary_image"
                            :src="previewImg"
                            @error="(e) => appUtils.onHandleErrorLoadImage(e)"
                          />
                          <div
                            class="preview-image__item cursor-pointer w-100"
                            v-show="!form.primary_image"
                          >
                            <div class="m-auto text-center">
                              <feather-icon size="32" icon="ImageIcon" />
                              <div class="text-center mt-1">
                                {{ $t("lbl_feature_image") }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <span>Ảnh minh hoạ</span>
                        <div
                          class="d-flex flex-wrap thumbs-image"
                          style="margin: 0 -4px"
                        >
                          <div
                            class="thumbs-image__item"
                            v-for="(thumb, index) in thumbsImg"
                            :key="`thumb_${index}`"
                            style="padding: 0 4px"
                          >
                            <div
                              class="thumbs-image__item-wrap position-relative d-flex cursor-pointer"
                            >
                              <b-img
                                class="w-100 border rounded"
                                :src="thumb.url"
                                @error="
                                  (e) => appUtils.onHandleErrorLoadImage(e)
                                "
                              />
                              <div
                                class="thumbs-image__clear"
                                @click="removeThumbImg(index)"
                              >
                                <feather-icon
                                  class="m-auto"
                                  size="16"
                                  icon="XIcon"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="!isDisableEdit"
                            class="thumbs-image__item d-flex"
                            style="padding: 0 4px"
                            @click="triggerChooseThumbImage"
                          >
                            <div
                              class="thumbs-image__item-wrap position-relative border rounded d-flex flex-grow w-100 cursor-pointer"
                            >
                              <feather-icon
                                class="m-auto"
                                size="20"
                                icon="PlusIcon"
                              />
                            </div>
                          </div>
                        </div>
                        <small class="text-muted">
                          {{ $t("lbl_required_image_resolution") }}
                        </small>
                        <input
                          hidden
                          ref="refInputEl"
                          type="file"
                          accept=".jpg, .png"
                          :placeholder="$t('lbl_choose_file')"
                          @input="handleSelectPreviewImage"
                        />
                        <input
                          hidden
                          ref="refInputThumbEl"
                          type="file"
                          multiple
                          accept=".jpg, .png"
                          :placeholder="$t('lbl_choose_file')"
                          @input="handleSelectThumbsImage"
                        />
                      </b-media-body>
                    </b-media>
                  </b-col>
                  <b-col cols="12" md="8" xxl="9" order-md="first">
                    <b-row>
                      <h5
                        class="border-left-primary pl-50 mb-2 ml-1"
                        style="border-left-width: 4px"
                      >
                        {{ $t("lbl_product_detail") }}
                      </h5>
                      <b-col cols="12" class="flex">
                        <b-form-group>
                          <b-form-checkbox
                            v-model="form.is_medicine"
                            :disabled="isDisableEdit"
                            @change="handleChangeIsMedicine"
                            >{{ $t("Sản phẩm là thuốc") }}</b-form-checkbox
                          >
                        </b-form-group>
                        <b-form-group v-if="form.is_medicine" class="ml-2">
                          <b-form-checkbox
                            v-model="form.is_prescription_required"
                            :disabled="isDisableEdit"
                            >{{
                              $t("lbl_this_is_a_prescription_medicine")
                            }}</b-form-checkbox
                          >
                        </b-form-group>
                        <b-form-group class="ml-2">
                          <b-form-checkbox
                            v-model="form.view"
                            :disabled="isDisableEdit"
                            >{{ $t("lbl_is_view_web") }}</b-form-checkbox
                          >
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('lbl_product_name')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_product_name')"
                            rules="required"
                          >
                            <b-form-input v-model="form.name" />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('lbl_register_number')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_register_number')"
                          >
                            <b-form-input
                              type="number"
                              v-model="form.registration_number"
                              @paste="preventPasteInvalidNumberKey"
                              @keypress="preventInvalidNumberKey"
                            />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group class="mb-2">
                          <div
                            class="flex gap-1 items-center"
                            style="padding-bottom: 8px"
                          >
                            <label
                              class="mb-0"
                              style="font-size: 14px; color: rgb(110, 107, 123)"
                              >SKU</label
                            >
                            <svg
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              v-b-tooltip.hover.top="
                                'Mã SKU là mã không trùng lặp để định danh giữa các sản phẩm.'
                              "
                              width="16"
                              height="16"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.75 22C17.75 22.1989 17.671 22.3897 17.5303 22.5303C17.3897 22.671 17.1989 22.75 17 22.75C16.5359 22.75 16.0908 22.5656 15.7626 22.2374C15.4344 21.9092 15.25 21.4641 15.25 21V16C15.25 15.9337 15.2237 15.8701 15.1768 15.8232C15.1299 15.7763 15.0663 15.75 15 15.75C14.8011 15.75 14.6103 15.671 14.4697 15.5303C14.329 15.3897 14.25 15.1989 14.25 15C14.25 14.8011 14.329 14.6103 14.4697 14.4697C14.6103 14.329 14.8011 14.25 15 14.25C15.4641 14.25 15.9093 14.4344 16.2374 14.7626C16.5656 15.0908 16.75 15.5359 16.75 16V21C16.75 21.0663 16.7763 21.1299 16.8232 21.1768C16.8701 21.2237 16.9337 21.25 17 21.25C17.1989 21.25 17.3897 21.329 17.5303 21.4697C17.671 21.6103 17.75 21.8011 17.75 22ZM15.5 11.75C15.7472 11.75 15.9889 11.6767 16.1945 11.5393C16.4 11.402 16.5602 11.2068 16.6549 10.9784C16.7495 10.7499 16.7742 10.4986 16.726 10.2561C16.6778 10.0137 16.5587 9.79093 16.3839 9.61612C16.2091 9.4413 15.9863 9.32225 15.7439 9.27402C15.5014 9.22579 15.2501 9.25054 15.0217 9.34515C14.7932 9.43976 14.598 9.59998 14.4607 9.80554C14.3233 10.0111 14.25 10.2528 14.25 10.5C14.25 10.8315 14.3817 11.1495 14.6161 11.3839C14.8505 11.6183 15.1685 11.75 15.5 11.75ZM28.75 16C28.75 18.5217 28.0022 20.9868 26.6012 23.0835C25.2003 25.1802 23.209 26.8144 20.8792 27.7795C18.5495 28.7445 15.9859 28.997 13.5126 28.505C11.0393 28.0131 8.76751 26.7987 6.98439 25.0156C5.20127 23.2325 3.98696 20.9607 3.49499 18.4874C3.00303 16.0141 3.25552 13.4505 4.22054 11.1208C5.18556 8.79103 6.81976 6.79975 8.91648 5.39876C11.0132 3.99777 13.4783 3.25 16 3.25C19.3803 3.25397 22.621 4.59854 25.0112 6.98877C27.4015 9.379 28.746 12.6197 28.75 16ZM27.25 16C27.25 13.775 26.5902 11.5999 25.354 9.74984C24.1179 7.89978 22.3609 6.45784 20.3052 5.60636C18.2495 4.75487 15.9875 4.53208 13.8052 4.96617C11.623 5.40025 9.6184 6.47171 8.04505 8.04505C6.47171 9.61839 5.40025 11.6229 4.96617 13.8052C4.53209 15.9875 4.75488 18.2495 5.60636 20.3052C6.45785 22.3609 7.89979 24.1179 9.74984 25.354C11.5999 26.5902 13.775 27.25 16 27.25C18.9827 27.2467 21.8422 26.0604 23.9513 23.9513C26.0604 21.8422 27.2467 18.9827 27.25 16Z"
                                fill="#0C0C0C"
                              />
                            </svg>
                          </div>
                          <validation-provider #default="{ errors }" name="SKU">
                            <b-form-input v-model="form.sku" />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" class="flex">
                        <b-form-group class="mb-2" style="width: 90%">
                          <div
                            class="flex gap-1 items-center"
                            style="padding-bottom: 8px"
                          >
                            <label
                              class="mb-0"
                              style="font-size: 14px; color: rgb(110, 107, 123)"
                              >{{ $t("lbl_category") }}</label
                            >
                            <svg
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              v-b-tooltip.hover.top="
                                'Danh mục là tập hợp các sản phẩm được nhóm lại với nhau bởi sự tương đồng dựa trên các tiêu chí như cùng chức năng, cùng ngành hàng/ chủng loại,....'
                              "
                              width="16"
                              height="16"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.75 22C17.75 22.1989 17.671 22.3897 17.5303 22.5303C17.3897 22.671 17.1989 22.75 17 22.75C16.5359 22.75 16.0908 22.5656 15.7626 22.2374C15.4344 21.9092 15.25 21.4641 15.25 21V16C15.25 15.9337 15.2237 15.8701 15.1768 15.8232C15.1299 15.7763 15.0663 15.75 15 15.75C14.8011 15.75 14.6103 15.671 14.4697 15.5303C14.329 15.3897 14.25 15.1989 14.25 15C14.25 14.8011 14.329 14.6103 14.4697 14.4697C14.6103 14.329 14.8011 14.25 15 14.25C15.4641 14.25 15.9093 14.4344 16.2374 14.7626C16.5656 15.0908 16.75 15.5359 16.75 16V21C16.75 21.0663 16.7763 21.1299 16.8232 21.1768C16.8701 21.2237 16.9337 21.25 17 21.25C17.1989 21.25 17.3897 21.329 17.5303 21.4697C17.671 21.6103 17.75 21.8011 17.75 22ZM15.5 11.75C15.7472 11.75 15.9889 11.6767 16.1945 11.5393C16.4 11.402 16.5602 11.2068 16.6549 10.9784C16.7495 10.7499 16.7742 10.4986 16.726 10.2561C16.6778 10.0137 16.5587 9.79093 16.3839 9.61612C16.2091 9.4413 15.9863 9.32225 15.7439 9.27402C15.5014 9.22579 15.2501 9.25054 15.0217 9.34515C14.7932 9.43976 14.598 9.59998 14.4607 9.80554C14.3233 10.0111 14.25 10.2528 14.25 10.5C14.25 10.8315 14.3817 11.1495 14.6161 11.3839C14.8505 11.6183 15.1685 11.75 15.5 11.75ZM28.75 16C28.75 18.5217 28.0022 20.9868 26.6012 23.0835C25.2003 25.1802 23.209 26.8144 20.8792 27.7795C18.5495 28.7445 15.9859 28.997 13.5126 28.505C11.0393 28.0131 8.76751 26.7987 6.98439 25.0156C5.20127 23.2325 3.98696 20.9607 3.49499 18.4874C3.00303 16.0141 3.25552 13.4505 4.22054 11.1208C5.18556 8.79103 6.81976 6.79975 8.91648 5.39876C11.0132 3.99777 13.4783 3.25 16 3.25C19.3803 3.25397 22.621 4.59854 25.0112 6.98877C27.4015 9.379 28.746 12.6197 28.75 16ZM27.25 16C27.25 13.775 26.5902 11.5999 25.354 9.74984C24.1179 7.89978 22.3609 6.45784 20.3052 5.60636C18.2495 4.75487 15.9875 4.53208 13.8052 4.96617C11.623 5.40025 9.6184 6.47171 8.04505 8.04505C6.47171 9.61839 5.40025 11.6229 4.96617 13.8052C4.53209 15.9875 4.75488 18.2495 5.60636 20.3052C6.45785 22.3609 7.89979 24.1179 9.74984 25.354C11.5999 26.5902 13.775 27.25 16 27.25C18.9827 27.2467 21.8422 26.0604 23.9513 23.9513C26.0604 21.8422 27.2467 18.9827 27.25 16Z"
                                fill="#0C0C0C"
                              />
                            </svg>
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_category')"
                          >
                            <v-select
                              id="category"
                              v-model="form.categories_id"
                              :reduce="(option) => option.id"
                              label="name"
                              value="id"
                              :clearable="false"
                              :options="categoryOption"
                              :calculate-position="withPopper"
                              multiple
                            >
                              <template slot="no-options">{{
                                $t("lbl_no_option")
                              }}</template>
                            </v-select>
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-form-group>
                        <div class="append_cate">
                          <b-button
                            v-b-tooltip.hover
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-primary"
                            class="btn-add-category"
                            @click="openCateModal(TYPE_CATE.category)"
                          >
                            <feather-icon size="22" icon="PlusIcon" />
                          </b-button>
                        </div>
                      </b-col>
                      <b-col v-show="form.is_medicine" cols="6">
                        <b-form-group
                          :label="$t('lbl_dosage_form')"
                          class="mb-2"
                        >
                          <v-select
                            id="dosage_form"
                            push-tags
                            taggable
                            :createOption="handleLog"
                            v-model="form.dosage_form_id"
                            :reduce="(option) => option.id"
                            label="name"
                            value="id"
                            :clearable="false"
                            :options="dosageFormsOption"
                            :calculate-position="withPopper"
                          >
                            <template slot="no-options">
                              {{ $t("lbl_no_option") }}
                            </template>
                            <template v-slot:option="option"
                              >{{ option.name }}
                              {{ !option.id ? "(Tạo)" : "" }}</template
                            >
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('lbl_packaging')"
                          class="mb-2 relative"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_packaging')"
                          >
                            <v-select
                              id="dosage_form"
                              push-tags
                              taggable
                              :createOption="handleLog"
                              :reduce="(option) => option.id"
                              v-model="form.specification_id"
                              label="name"
                              value="id"
                              :clearable="false"
                              :options="specificationsOption"
                              :calculate-position="withPopper"
                            >
                              <template slot="no-options">
                                {{ $t("lbl_no_option") }}
                              </template>
                              <template v-slot:option="option"
                                >{{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}</template
                              >
                            </v-select>
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                            <div
                              v-if="form.specification_id"
                              @click="form.specification_id = 0"
                              class="cs-close-icon"
                            >
                              <feather-icon icon="XIcon" />
                            </div>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <!-- <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_slug')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_slug')"
                            rules="required"
                          >
                            <b-input-group :prepend="`${domain}products/`">
                              <b-form-input v-model="form.slug" />
                              <b-input-group-append>
                                <b-button
                                  variant="outline-primary"
                                  @click="generateSlug"
                                  >{{ $t('lbl_generate') }}</b-button
                                >
                              </b-input-group-append>
                            </b-input-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>-->
                      <!-- Select Unit -->
                      <b-col cols="12">
                        <b-card bg-variant="light">
                          <b-row
                            v-for="(item, index) in form.ecom_product_variants"
                            :id="item.id || item.code || index"
                            :key="item.id || item.code || index"
                            :set="(isMinimumUnit = item.conversion_rate === 1)"
                          >
                            <b-col cols="12" md="4" class="px-50">
                              <b-form-group
                                :label="$t('lbl_unit_price')"
                                class="required"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`input-price-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_unit_price')"
                                  rules="required"
                                >
                                  <b-input-group append="VNĐ">
                                    <cleave
                                      v-model="item.price"
                                      class="form-control"
                                      :id="`input-price-${
                                        item.id || item.code || index
                                      }`"
                                      :raw="false"
                                      :options="cleaveOptions.numberUnit"
                                      placeholder="10,000"
                                    />
                                  </b-input-group>
                                  <small
                                    v-if="errors.length"
                                    class="text-danger"
                                    >{{ errors[0] }}</small
                                  >
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4" class="px-50">
                              <b-form-group
                                :label="
                                  isMinimumUnit
                                    ? $t('lbl_minimum_unit')
                                    : $t('lbl_unit')
                                "
                                class="w-100 required relative"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`select-unit-${
                                    item.id || item.code || index
                                  }`"
                                  :name="
                                    isMinimumUnit
                                      ? $t('lbl_minimum_unit')
                                      : $t('lbl_unit')
                                  "
                                  rules="required"
                                >
                                  <v-select
                                    class="bg-white"
                                    push-tags
                                    taggable
                                    :createOption="handleLog"
                                    v-model="item.ecom_unit"
                                    label="name"
                                    value="ecom_unit_id"
                                    append-to-body
                                    :id="`select-unit-${
                                      item.id || item.code || index
                                    }`"
                                    :clearable="false"
                                    :options="unitsOption"
                                    :calculate-position="withPopper"
                                    @input="
                                      (value) => handleSelectUnit(value, index)
                                    "
                                  >
                                    <template slot="no-options">
                                      {{ $t("lbl_no_option") }}
                                    </template>
                                    <template v-slot:option="option"
                                      >{{ option.name }}
                                      {{ !option.id ? "(Tạo)" : "" }}</template
                                    >
                                  </v-select>
                                  <small
                                    v-if="errors.length"
                                    class="text-danger"
                                    >{{ errors[0] }}</small
                                  >
                                  <div
                                    v-if="item.ecom_unit_id"
                                    @click="item.ecom_unit = 0"
                                    class="cs-close-icon"
                                  >
                                    <feather-icon icon="XIcon" />
                                  </div>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              v-if="!isMinimumUnit"
                              cols="12"
                              md="2"
                              class="px-50"
                            >
                              <b-form-group
                                :label="$t('lbl_conversion_rate')"
                                class="w-100 required"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`select-unit-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_conversion_rate')"
                                  rules="required"
                                >
                                  <b-input-group
                                    :append="minimumUnit.ecom_unit.name"
                                  >
                                    <cleave
                                      v-model="item.conversion_rate"
                                      class="form-control"
                                      :id="`input-conversion-rate-${
                                        item.id || item.code || index
                                      }`"
                                      :raw="false"
                                      placeholder="10"
                                      :options="cleaveOptions.number"
                                    />
                                  </b-input-group>
                                  <small
                                    v-if="errors.length"
                                    class="text-danger"
                                    >{{ errors[0] }}</small
                                  >
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col cols="12" md="2" class="px-50">
                              <div class="d-flex">
                                <div
                                  class="text-nowrap ml-1"
                                  style="margin-top: 27.42px"
                                >
                                  <b-button
                                    v-if="
                                      form.ecom_product_variants.length > 1 &&
                                      !isMinimumUnit &&
                                      !productId
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('lbl_remove')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-danger"
                                    class="p-50"
                                    @click="
                                      removeItem(
                                        index,
                                        form.ecom_product_variants,
                                        handleRemoveVariant(item.id)
                                      )
                                    "
                                  >
                                    <feather-icon size="22" icon="Trash2Icon" />
                                    <span class="sr-only">
                                      {{ $t("lbl_remove") }}
                                    </span>
                                  </b-button>
                                </div>
                              </div>
                            </b-col>
                            <b-col
                              v-if="form.ecom_product_variants.length > 1"
                              cols="12"
                              class="px-50"
                            >
                              <b-form-group class="mb-0">
                                <b-form-radio
                                  :disabled="isDisableEdit"
                                  v-model="item.default"
                                  name="unit-radios"
                                  :value="2"
                                  @change="
                                    (value) =>
                                      handleSetDefaultPriceUnit(value, index)
                                  "
                                  >{{ $t("lbl_default_price") }}</b-form-radio
                                >
                              </b-form-group>
                            </b-col>
                            <b-col
                              v-if="
                                index !==
                                  form.ecom_product_variants.length - 1 &&
                                form.ecom_product_variants.length > 1
                              "
                              cols="12"
                            >
                              <hr />
                            </b-col>
                            <b-col
                              cols="12"
                              class="px-50"
                              :class="{ 'mt-2': index !== 0 }"
                            >
                              <div class="d-flex justify-start">
                                <div class="text-nowrap">
                                  <b-button
                                    v-if="
                                      index ===
                                      form.ecom_product_variants.length - 1
                                    "
                                    :disabled="
                                      !minimumUnit.price ||
                                      !minimumUnit.ecom_unit_id
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('lbl_add_new')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-primary"
                                    class="p-50"
                                    style="border: none !important"
                                    @click="
                                      addNewUnitItem(form.ecom_product_variants)
                                    "
                                  >
                                    <feather-icon
                                      size="18"
                                      icon="PlusIcon"
                                      style="margin-bottom: 2.5px"
                                    />
                                    <span
                                      style="
                                        line-height: 22px;
                                        display: inline-block;
                                        margin-left: 5px;
                                      "
                                    >
                                      {{ $t("lbl_add_new") }}
                                    </span>
                                  </b-button>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-col>
                      <!-- End of Select Unit -->

                      <b-col cols="12">
                        <h5
                          class="border-left-primary pl-50 mb-2"
                          style="border-left-width: 4px"
                        >
                          {{ $t("lbl_origin") + " / " + $t("lbl_origination") }}
                        </h5>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('lbl_manufacture')"
                          class="mb-2 relative"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_manufacture')"
                          >
                            <v-select
                              id="manufacturer_id"
                              push-tags
                              taggable
                              :createOption="handleLog"
                              :reduce="(option) => option.id"
                              v-model="form.manufacturer_id"
                              label="name"
                              value="id"
                              :clearable="false"
                              :options="manufacturersOption"
                              :calculate-position="withPopper"
                            >
                              <template slot="no-options">
                                {{ $t("lbl_no_option") }}
                              </template>
                              <template v-slot:option="option"
                                >{{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}</template
                              >
                            </v-select>
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                            <div
                              v-if="form.manufacturer_id"
                              @click="form.manufacturer_id = 0"
                              class="cs-close-icon"
                            >
                              <feather-icon icon="XIcon" />
                            </div>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('lbl_brand')"
                          class="mb-2 relative"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_brand')"
                          >
                            <v-select
                              id="brand_id"
                              push-tags
                              taggable
                              :createOption="handleLog"
                              :reduce="(option) => option.id"
                              v-model="form.ecom_brand_id"
                              label="name"
                              value="id"
                              :clearable="false"
                              :options="brandsOption"
                              :calculate-position="withPopper"
                            >
                              <template slot="no-options">
                                {{ $t("lbl_no_option") }}
                              </template>
                              <template v-slot:option="option"
                                >{{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}</template
                              >
                            </v-select>
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                            <div
                              v-if="form.ecom_brand_id"
                              @click="form.ecom_brand_id = 0"
                              class="cs-close-icon"
                            >
                              <feather-icon icon="XIcon" />
                            </div>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('lbl_origin')"
                          class="mb-2 relative"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_origin')"
                            rules
                          >
                            <v-select
                              id="origin_id"
                              push-tags
                              taggable
                              :createOption="handleLog"
                              :reduce="(option) => option.id"
                              v-model="form.origin_id"
                              label="name"
                              value="id"
                              :clearable="false"
                              :options="originsOption"
                              :calculate-position="withPopper"
                            >
                              <template slot="no-options">
                                {{ $t("lbl_no_option") }}
                              </template>
                              <template v-slot:option="option"
                                >{{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}</template
                              >
                            </v-select>
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                            <div
                              v-if="form.origin_id"
                              @click="form.origin_id = 0"
                              class="cs-close-icon"
                            >
                              <feather-icon icon="XIcon" />
                            </div>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <h5
                          class="border-left-primary pl-50 mb-2"
                          style="border-left-width: 4px"
                        >
                          {{ $t("lbl_ingredients_description") }}
                        </h5>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_short_description')"
                          class="mb-2"
                        >
                          <b-form-textarea
                            class="scrollbar"
                            v-model="form.short_desc"
                            rows="3"
                            max-rows="20"
                          />
                        </b-form-group>
                        <b-form-group
                          :label="$t('lbl_description_marketplace')"
                          class="mb-2"
                        >
                          <quill-editor
                            v-show="showQuillEditor"
                            v-model="form.description"
                            :options="optionsEditor"
                            :disabled="isDisableEdit"
                          />
                        </b-form-group>
                        <b-form-group
                          :label="$t('lbl_ingredients')"
                          class="mb-2"
                        >
                          <b-form-textarea
                            class="scrollbar"
                            v-model="form.ingredient"
                            rows="3"
                            max-rows="20"
                          />
                        </b-form-group>
                      </b-col>

                      <template v-if="form.is_medicine">
                        <b-col cols="12">
                          <h5
                            class="border-left-primary pl-50 mb-2"
                            style="border-left-width: 4px"
                          >
                            {{ $t("lbl_indicative_contraindicated") }}
                          </h5>
                        </b-col>

                        <b-col cols="12">
                          <b-form-group
                            :label="$t('lbl_indicative')"
                            class="mb-2"
                          >
                            <b-form-textarea
                              class="scrollbar"
                              v-model="form.indication"
                              rows="3"
                              max-rows="20"
                            />
                          </b-form-group>
                          <b-form-group
                            :label="$t('lbl_contraindicated')"
                            class="mb-2"
                          >
                            <b-form-textarea
                              class="scrollbar"
                              v-model="form.contraindicated"
                              rows="3"
                              max-rows="20"
                            />
                          </b-form-group>
                          <b-form-group :label="$t('lbl_note')" class="mb-2">
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_note')"
                            >
                              <b-form-textarea
                                class="scrollbar"
                                v-model="form.notes"
                                rows="3"
                                max-rows="20"
                              />
                              <small v-if="errors.length" class="text-danger">{{
                                errors[0]
                              }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </template>
                    </b-row>
                  </b-col>
                </b-row>
              </b-form>
            </b-overlay>
            <!--/ form -->
          </validation-observer>
        </div>
      </b-tab>
    </b-tabs>
    <b-row v-if="!isDisableEdit">
      <b-col cols="12">
        <b-button
          v-if="productId"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-1"
          :disabled="isLoading"
          @click="updateProduct"
          >{{ $t("lbl_update_product") }}</b-button
        >
        <b-button
          v-else
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-1"
          :disabled="isLoading"
          @click="addProduct"
          >{{ $t("lbl_add_new") }}</b-button
        >
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          :to="{ name: 'products-marketplace' }"
          :disabled="isLoading"
          variant="outline-secondary"
          >{{ $t("lbl_cancel") }}</b-button
        >
      </b-col>
    </b-row>
    <category-modal
      :is-show-category-modal.sync="isShowCategoryModal"
      :type="typeCate"
      @commitData="commitData"
    />
  </b-card>
</template>

<script>
import vSelect from "vue-select";
import { quillEditor } from "vue-quill-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import useAddProduct from "./useAddProduct";
import Cleave from "vue-cleave-component";
// eslint-disable-next-line import/no-extraneous-dependencies
import "cleave.js/dist/addons/cleave-phone.vi";
import { createPopper } from "@popperjs/core";
// import ProductCertificates from './Certificates.vue'
import appUtils from "@/utils/appUtils";
import { PRODUCT_ON_HODO, PRODUCT_TYPES, TYPE_CATE } from "@/utils/constant";
import CategoryModal from "../Modal/CategoryModal.vue";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

export default {
  name: "AddAndUpdateProductMarketplace",
  components: {
    vSelect,
    Cleave,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    // ProductCertificates,
    CategoryModal,
    FeatherIcon,
  },
  directives: {
    Ripple,
  },
  setup() {
    const mixData = useAddProduct();
    const toast = useToast();
    return { ...mixData, toast, useToast };
  },
  data() {
    return {
      required,
      cleaveOptions: {
        numberUnit: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
        number: {
          numeral: true,
        },
      },
      nextTodoId: 1,
      placement: "bottom",
      PRODUCT_TYPES,
      appUtils,
      isDisabledDeliverableDocs: true,
      isDisabledDeliverableStates: true,
      isDisabledAttachmentConfigs: true,
      PRODUCT_ON_HODO,
      currLanguage: this.$store.state.language.currLanguage,
      isDisableAddVariant: true,
      showQuillEditor: false,
      isShowCategoryModal: false,
      typeCate: 0,
      TYPE_CATE,
      valueInput: "",
    };
  },
  computed: {
    // ...mapGetters("app", ["lanCodeOptions", "statusOptions"]),
    isDisableEdit() {
      return this.$route.params.id && !this.$route.meta.isEditable;
    },
    minimumUnit() {
      return this.form.ecom_product_variants.find(
        (el) => el.conversion_rate === 1
      );
    },
  },
  async created() {
    this.isLoading = true;
    this.productId = this.$route.params?.id;
    this.fetchUnitList();
    this.fetchDosageFormList();
    this.fetchSpecificationList();
    this.fetchManufacturerList();
    this.fetchOriginList();
    this.fetchBrandList();
    this.fetchCategoryList();
    if (this.productId) {
      this.fetchProductById().then(() => {
        this.showQuillEditor = true;
      });
    } else this.showQuillEditor = true;
    this.isLoading = false;
  },
  mounted() {
    const userData = appUtils.getLocalUser();
    if (!userData?.supplierInfo?.id) return;
  },
  methods: {
    preventInvalidNumberKey(e) {
      const invalidChars = ["-", "+", "e", ".", ","];
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    },
    preventPasteInvalidNumberKey(e) {
      let numericPattern = /^[0-9]+$/; // Regular expression to match only numeric characters from 0-9
      let copyContent = e.clipboardData.getData("text/plain");
      if (!numericPattern.test(copyContent)) {
        e.preventDefault();
      }
    },
    async commitData(data) {
      const self = this;
      switch (this.typeCate) {
        case TYPE_CATE.category:
          await self.handleFetchCategory(data);
          // Danh mục
          break;
        default:
      }
    },
    openCateModal(type) {
      this.isShowCategoryModal = !this.isShowCategoryModal;
      this.typeCate = type;
    },
    checkRequireAll(registerItem) {
      registerItem.isRequired = !registerItem.isRequired;
      registerItem.child.forEach((child) => {
        child.isRequired = registerItem.isRequired;
      });
    },
    triggerChoosePreviewImage() {
      this.$refs.refInputEl.click();
    },
    triggerChooseThumbImage() {
      this.$refs.refInputThumbEl.click();
    },
    removeImage() {
      this.$refs.refInputEl.value = null;
      this.form.primary_image = null;
    },
    removeThumbImg(index) {
      this.form.thumbnail_image && this.form.thumbnail_image?.splice(index, 1);
      this.thumbsImg && this.thumbsImg?.splice(index, 1);
    },
    addNewUnitItem(data) {
      data.push({
        code: appUtils.randomCode(10),
        price: null,
        ecom_unit_id: null,
        conversion_rate: null,
        default: 1,
      });
    },
    addNewExpenseItem(data) {
      data.push({
        code: appUtils.randomCode(10),
        name: "",
        value: null,
        unit: "VNĐ",
      });
    },
    removeItem(index, data, callback) {
      data.splice(index, 1);
      if (callback instanceof Function) {
        callback();
      }
    },
    handleRemoveVariant(variant_id) {
      if (isNaN(variant_id)) return;

      this.$rf.getRequest("CommonRequest").deleteVariant(variant_id);
    },
    async handleSelectUnit(option, index) {
      if (option.id === null) {
        let index_create = this.form.ecom_product_variants.length - 1;
        await this.createUnit(option.name);
        await this.fetchUnitList();
        const variant = {
          ...this.form.ecom_product_variants[index_create],
          ecom_unit_id: this.form.ecom_product_variants[index_create].id,
          id: 0,
        };
        this.form.ecom_product_variants.splice(index, 1, variant);
      } else {
        const variant = {
          ...this.form.ecom_product_variants[index],
          ecom_unit_id: option.id,
        };
        this.form.ecom_product_variants.splice(index, 1, variant);
      }
    },
    handleSetDefaultPriceUnit(value, index) {
      this.form.ecom_product_variants = this.form.ecom_product_variants.map(
        (product, i) => {
          return {
            ...product,
            default: index === i ? value : 1,
          };
        }
      );
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });

      return () => popper.destroy();
    },
    setCertificates(value) {
      this.certificates = (value.length && [...value]) || [];
    },
    handleChangeFormRegisterProfile(item) {
      if (item.checked) {
        item.checked = false;
        item.isRequired = false;
      } else {
        item.checked = true;
      }
    },
    handleCollapseRegisterProfile(e, data) {
      data.checked = e.target.checked;
      data?.child.forEach((item) => {
        item.checked = e.target.checked;
      });
    },
    async handleFetchCategory(data) {
      await this.fetchCategoryList().then((res) => {
        if (res.status === 200) {
          this.form.categories_id = [...this.form.categories_id, data.data.id];
        }
      });
    },
    handleLog(data) {
      this.valueInput = data;
      return {
        name: data,
        id: null,
      };
    },
    async createDosageForm(data) {
      try {
        return await store
          .dispatch("configProduct/createDosageForm", {
            name: data,
            description: "",
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id,
          })
          .then((response) => {
            const newID = response.data.id;
            this.form.dosage_form_id = newID;
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Thêm dạng bào chế thành công",
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            return true;
          });
      } catch (error) {
        console.log(error);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi thêm dạng bào chế",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } finally {
        // isLoading.value = false
      }
    },
    async createSpecification(data) {
      try {
        return await store
          .dispatch("configProduct/createSpecification", {
            name: data,
            description: "",
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id,
          })
          .then((response) => {
            const newID = response.data.id;
            this.form.specification_id = newID;
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Thêm quy cách đóng gói thành công",
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            return true;
          });
      } catch (error) {
        console.log(error);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi thêm quy cách đóng gói",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } finally {
        // isLoading.value = false
      }
    },
    async createManufacturer(data) {
      try {
        return await store
          .dispatch("configProduct/createManufacturer", {
            name: data,
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id,
          })
          .then((response) => {
            const newID = response.data.id;
            this.form.manufacturer_id = newID;
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Thêm nhà sản xuất thành công",
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            return true;
          });
      } catch (error) {
        console.log(error);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi thêm nhà sản xuất",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } finally {
        // isLoading.value = false
      }
    },
    async createUnit(data) {
      try {
        return await store
          .dispatch("configProduct/createUnit", {
            name: data,
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id,
          })
          .then((response) => {
            const newID = response.data.id;
            this.form.ecom_product_variants[
              this.form.ecom_product_variants.length - 1
            ].id = newID;
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Thêm đơn vị thành công",
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            return true;
          });
      } catch (error) {
        console.log(error);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi thêm đơn vị",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } finally {
        // isLoading.value = false
      }
    },
    async createBrand(data) {
      try {
        return await store
          .dispatch("configProduct/createBrand", {
            name: data,
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id,
          })
          .then((response) => {
            const newID = response.data.id;
            this.form.ecom_brand_id = newID;
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Thêm thương hiệu thành công",
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            return true;
          });
      } catch (error) {
        console.log(error);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi thêm thương hiệu",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } finally {
        // isLoading.value = false
      }
    },
    async createOrigin(data) {
      try {
        return await store
          .dispatch("configProduct/createOrigin", {
            name: data,
            description: "",
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id,
          })
          .then((response) => {
            const newID = response.data.id;
            this.form.origin_id = newID;
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Thêm nguồn gốc thành công",
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            return true;
          });
      } catch (error) {
        console.log(error);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi xảy ra khi thêm nguồn gốc",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      } finally {
        // isLoading.value = false
      }
    },
  },
  watch: {
    "$store.state.language.currLanguage": function () {
      this.currLanguage = this.$store.state.language.currLanguage;
    },
    "form.dosage_form_id": {
      async handler(value) {
        if (value !== null) return;
        else {
          await this.createDosageForm(this.valueInput);
          await this.fetchDosageFormList();
        }
      },
    },
    "form.origin_id": {
      async handler(value) {
        if (value !== null) return;
        else {
          await this.createOrigin(this.valueInput);
          await this.fetchOriginList();
        }
      },
    },
    "form.specification_id": {
      async handler(value) {
        if (value !== null) return;
        else {
          await this.createSpecification(this.valueInput);
          await this.fetchSpecificationList();
        }
      },
    },
    "form.ecom_brand_id": {
      async handler(value) {
        if (value !== null) return;
        else {
          await this.createBrand(this.valueInput);
          await this.fetchBrandList();
        }
      },
    },
    "form.manufacturer_id": {
      async handler(value) {
        if (value !== null) return;
        else {
          await this.createManufacturer(this.valueInput);
          await this.fetchManufacturerList();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.append_cate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .btn-add-category {
    margin-left: 12px;
    padding: 6px;
    margin-top: 4px;
  }
}

.disable {
  cursor: not-allowed;
  pointer-events: none;
  .form-control,
  .v-select,
  .input-group-text,
  .thumbs-image__item-wrap,
  .quill-editor {
    background-color: #f6f6f6 !important;
    cursor: not-allowed;
    pointer-events: none;
  }
  .input-group-append,
  .btn {
    opacity: 60%;
  }
  .vs__selected {
    opacity: 60%;
  }
}
.preview-image {
  position: relative;
  width: 100%;

  &::before {
    content: "";
    display: block;
    padding-top: percentage(720/1200);
    transition: all 0.3s ease;
    border-radius: 4px;
  }

  &:hover::before {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &__item {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__clear {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 32px;
    height: 32px;
    border-radius: 4px 0 4px 0;
    line-height: 1;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 4px;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(0, 0, 0, 0.9);
    }
  }
}
.thumbs-image {
  &__item {
    position: relative;
    width: 25%;
    height: 52px;
    transition: all 0.3s ease;

    // &:not(:last-child) {
    //   margin-right: 8px;
    // }

    &-wrap {
      height: 100%;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);

        .thumbs-image__clear {
          visibility: visible;
          opacity: 1;
        }
      }

      img {
        object-fit: cover;
      }
    }
  }

  &__clear {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform-origin: center;
    visibility: hidden;
    opacity: 0;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.75);
    color: white;
    transition: all 0.3s ease;
  }
}
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.cs-card .card-body {
  padding: 12px;
}

.not-collapsed > .when-open {
  transform: rotate(90deg);
}
.scrollbar {
  overflow-y: auto !important;
  /* width */
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background: rgba(241, 241, 241, 0.4);
    border-radius: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background: #b9b9b9;
  }

  /* Handle on hover */
  // ::-webkit-scrollbar-thumb:hover {
  // }

  &::-webkit-scrollbar-corner {
    display: none;
  }
}

.cs-close-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 26px;
  cursor: pointer;
  z-index: 10;
}
</style>
